import React, { Component } from "react";
import { Translation } from "react-i18next";
import { animated } from "react-spring/renderprops.cjs";
import { noop } from "../../../utils/noop";
import { Icon } from "../../Icon/Icon";
import "./Select.css";

export * from "./SelectOption/SelectOption";

/**
 *  @param {object} props
 *  @param {*} props.children
 *
 *
 * @export
 * @class Select
 * @extends {Component}
 */
export class Select extends Component {
  state = {
    isOpen: false,
  };

  node;
  optionsNode;

  toggle = () => {
    this.state.isOpen ? this.close() : this.open();
  };

  open() {
    this.setState({ isOpen: true });
    this.addOutsideClickHandler();
    this.scrollContainerToSelectedOption();
  }

  close() {
    this.setState({ isOpen: false });
    this.removeOutsideClickHandler();
  }

  select(value) {
    this.props.change(value);
    if (this.props.withSearch) {
      this.props.onQueryChange({ target: { value } });
    }
    this.close();
  }

  getLabel(value) {
    const selectedChild = React.Children.toArray(this.props.children).find(
      /**
       *
       *
       * @param {*} child
       * @prop {*} child.props
       */
      (child) => child.props.value === value
    );

    return selectedChild
      ? selectedChild.props.children
      : this.props.disabled
      ? "Deactivated"
      : "generic.selectOption";
  }

  scrollContainerToSelectedOption() {
    if (this.optionsNode) {
      const selectedNodes = this.optionsNode.getElementsByClassName(
        "is-selected"
      );

      if (selectedNodes.length > 0 && selectedNodes[0].scrollIntoView) {
        selectedNodes[0].scrollIntoView();
      }
    }
  }

  outsideClickHandler = (e) => {
    // Don't trigger on the component node
    if (this.node.contains(e.target)) {
      return;
    }

    this.close();
  };

  addOutsideClickHandler() {
    document.addEventListener("mousedown", this.outsideClickHandler);
  }

  removeOutsideClickHandler() {
    document.removeEventListener("mousedown", this.outsideClickHandler);
  }

  render() {
    const childrenWithSelectedPoperty = React.Children.map(
      this.props.children,
      (child) => {
        return React.cloneElement(child, {
          click: (value) => this.select(value),
          isSelected: child.props.value === this.props.value,
        });
      }
    );

    const classes = ["Select"];

    classes.push(`Select--${this.props.type}`);

    if (this.state.isOpen) {
      classes.push("is-open");
    }

    if (this.props.disabled) {
      classes.push("Select--disabled");
    }

    return (
      <Translation>
        {(t) => (
          <div className={classes.join(" ")} ref={(node) => (this.node = node)}>
            <div className="Select__element">
              {this.props.withSearch && this.state.isOpen && (
                <input
                  autoFocus={true}
                  className="Select__query"
                  value={this.props.query}
                  onChange={(e) => this.props.onQueryChange(e)}
                />
              )}
              <div
                className="Select__value u-no-text-select"
                onClick={this.props.disabled ? noop : this.toggle}
              >
                {t(this.getLabel(this.props.value))}
              </div>
              <Icon
                name="iconDropdown"
                width={12}
                height={7}
                className="Select__icon"
              />
            </div>

            <animated.div
              className="Select__options"
              ref={(node) => (this.optionsNode = node)}
            >
              {childrenWithSelectedPoperty}
            </animated.div>
          </div>
        )}
      </Translation>
    );
  }
}
